import React from 'react';
const ReloadLightIcon = ({ width, height }) => (
    <svg className="icon reload-light-icon" width={width} height={height} viewBox="0 0 24 24">
        <path d="M12 24C5.37258 24 0 18.6274 0 12C0 11.7239 0.223858 11.5 0.5 11.5C0.776142 11.5 1 11.7239 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C8.95793 1 6.11995 2.24192 4.06819 4.37823L7.44478 4.00306C7.71924 3.97256 7.96645 4.17033 7.99694 4.44478C8.02744 4.71924 7.82967 4.96645 7.55522 4.99694L3.05522 5.49694C2.75903 5.52985 2.5 5.29801 2.5 5V0.5C2.5 0.223858 2.72386 0 3 0C3.27614 0 3.5 0.223858 3.5 0.5V3.52906C5.72489 1.29491 8.75693 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24Z" />
    </svg>
);

export default ReloadLightIcon;
